import K from "../../../utilities/constants";
import { displayDollar, displayHire } from "../../../utilities/tableUtility";

export const getThresholdValue = (thresholdType, value) => {
  return thresholdType === K.CommissionThresholdType.Amount
    ? displayDollar(value)
    : displayHire(value);
};

export const getThresholdTypeDisplayValue = (thresholdType, value) => {
  const label =
    thresholdType === K.CommissionThresholdType.Amount
      ? "Billing Threshold"
      : "Hire Threshold";

  return `${label}: ${getThresholdValue(thresholdType, value)}`;
};

export const calculateTotal = (type, total, curr) => {
  const bill = curr.submittedJobBill;

  if (type === K.CommissionThresholdType.Amount) {
    return total + curr.thresholdMaker;
  }

  if (type === K.CommissionThresholdType.TotalHire) {
    if (bill.billingRuleEntry?.jobBillingTypesId === 1) return total + 1;
    if (bill.billingTypeName === "Hire Fee (credit)") return total - 1;
  }

  return total;
};

export const getApprovalsTotal = (
  selectedRows,
  thresholdType,
  clientExceptions,
) => {
  const initialValue = {
    total: 0,
    exceptionsTotal: {},
    selected: [],
    recruiterId: null,
    thresholdType: K.CommissionThresholdType.Amount,
  };

  return selectedRows.reduce((prev, curr) => {
    const ex = clientExceptions[curr.submittedJobBill.clientId];
    const prevExTotal = prev.exceptionsTotal[ex?.id] || 0;

    const newTotal = !ex
      ? calculateTotal(thresholdType, prev.total, curr)
      : prev.total;

    const exceptionsTotal = ex
      ? {
          ...prev.exceptionsTotal,
          [ex.id]: calculateTotal(ex.thresholdType, prevExTotal, curr),
        }
      : prev.exceptionsTotal;

    return {
      thresholdType,
      total: newTotal,
      exceptionsTotal,
      selected: [...prev.selected, curr.id],
      recruiterId: curr.recrutorId,
    };
  }, initialValue);
};
